import SchedulesSection from './SchedulesSection';

export default SchedulesSection;
